module.exports = __webpack_public_path__ + "img/safe01.797bdb17.png";